import React from "react";
import { Link } from "react-router-dom";
import "./privacy.css";

export default function PrivacyHub() {
  return (
    <div className="overview1-container">
      <h2>개인정보처리방침</h2>

      <div className="overview1-row">
        <div className="overview1-title">안내</div>
        <div className="overview1-value">
          본 페이지는 TAMA의 앱별 개인정보처리방침 문서를 안내합니다.
          해당 앱별 문서 목록을 클릭하여 확인해주세요.
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">문서 목록</div>
        <div className="overview1-value">
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <Link to="/privacy/fmc-aurora">
              FMC Aurora <span className="badge">Bluetooth Device Control</span>
            </Link>

            {/* 앞으로 앱이 늘어나면 아래처럼 계속 추가하면 됩니다 */}
            {/* <Link to="/privacy/iot-sensor">IoT Sensor V1</Link> */}
            {/* <Link to="/privacy/heat-control">Heat Control</Link> */}
          </div>
        </div>
      </div>

      <div className="overview1-row">
        <div className="overview1-title">문의</div>
        <div className="overview1-value">
          이메일: <a href="mailto:tama@ta-ma.net">tama@ta-ma.net</a>
        </div>
      </div>
    </div>
  );
}
